var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useAuthProvider } from '#context';
import { usePlugFilespaceClient } from '../../../hooks';
import { FilespaceEntryIdKeyFactory } from '../../../query-key-factories';
export const useFsEntryGetKey = ({ filespaceId, fsEntryPath, workspaceId, }) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const query = useQuery({
        queryKey: FilespaceEntryIdKeyFactory.exact(filespaceId, fsEntryPath || ''),
        queryFn: async () => {
            if (fsEntryPath === null) {
                return null;
            }
            return plugFilespaceClient({
                action: (fsClient) => fsClient.fileSystem().getEntryKey(fsEntryPath),
                filespaceId,
                workspaceId,
            });
        },
        enabled: Boolean(currentUser?.emailVerified && fsEntryPath !== null),
        networkMode: 'always',
    });
    return { query };
};
_react_refresh_temp_1(useFsEntryGetKey, "jRMx3r7nIBDWbUBVlsDJFgWprew=", false, () => [useAuthProvider, usePlugFilespaceClient, useQuery]);
